module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-论坛选择标签-蓝.b3e09.png";